import { BaseResource } from 'utils/ApiUtils';


export default class Contractor extends BaseResource {
    constructor(args) {
      super(args, Contractor.attributes);
    };
  
    static columns = [
      { title: "Contractor", field: "Description_ContractorNavigation", defaultSort: "asc" },
      { title: "Contractor Type", field: "Description_ContractorType" },
      { title: "Active MBE", field: "MbeDesignation", type: "boolean" },
      { title: "MBE License Number", field: "MbeLicenseNumber" },
      { title: "Field Use", field: "FieldUse", type: "boolean" },
      { title: "ContractorProjectId", field: "ContractorProjectId", hidden: true },
      { title: "ContractorId", field: "ContractorId", hidden: true },
      { title: "Active?",  field: "IsActive", type: "boolean" },
      { title: "ContractorTypeId", field: "ContractorTypeId", hidden: true },
    ]
  
    static attributes = Contractor.columns.map(r => r.field);
  
    static expand = [
      { 'ContractorType': { select: ['Description'] } },
      {
        'ContractorNavigation': { select: ['Description'] }
      }];
  
  };